import React from 'react'
import './loader.css'

function PageLoader() {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    )
}

export default PageLoader